'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RailCardJourneyHeader(props) {
  var components = props.components,
      cardTypeText = props.cardTypeText;

  var styleRailCardNameContainer = (0, _emailStyleTools.containerStyles)(components, 'RailCardNameContainer');
  var styleRailCardLabel = (0, _emailStyleTools.textStyles)(components, 'RailCardLabel');

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'RailCardJourneyHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleRailCardNameContainer, { padding: '10px' }) },
          _react2.default.createElement(
            'span',
            { style: styleRailCardLabel },
            cardTypeText
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(RailCardJourneyHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailCardJourneyHeader.jsx
// module id = 1548
// module chunks = 0